var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcAdd20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 2.25a.75.75 0 0 1 .743.648L10.75 3v6.25H17a.75.75 0 0 1 .102 1.493L17 10.75h-6.25V17a.75.75 0 0 1-1.493.102L9.25 17v-6.25H3a.75.75 0 0 1-.102-1.493L3 9.25h6.25V3a.75.75 0 0 1 .75-.75"
})));
export default SvgIcAdd20X20;